var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoUsuario01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5,25.9H24l-1.4-2.2c2.2-1.7,4-4.2,4.3-6.8c0.8-0.4,1.2-1.2,1.2-2.3v-2.8c0-0.9-0.6-1.6-1.2-2.1V7.9 c1.3-1.9,1.2-4-0.4-5.6c-2.1-2.2-6.6-2.8-10.5-0.2c-5,0.1-7.2,1.8-7.2,5.4v2.2c-0.5,0.4-1.2,1.1-1.2,2.1v2.8c0,1.1,0.3,1.8,0.8,2.1 c0.3,2.6,2.1,5.4,4.3,7L11.3,26H9.9c-4.8,0-7.8,2.6-7.8,6.9v1.6c0,0.6,0.6,1.1,1.2,1.1s1.2-0.5,1.2-1.2v-1.6c0-3.8,2.9-4.6,5.5-4.6 h2.1c0.4,0,0.8-0.2,1-0.5l2-2.7c0.9,0.4,1.9,0.6,2.7,0.6c1,0,2.1-0.3,3-0.7l1.8,2.8c0.2,0.4,0.6,0.6,1,0.6h2.1 c1.4,0,5.9,0.3,5.9,4.6v1.6c0,0.7,0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2v-1.6C33.8,28.6,30.6,25.9,25.5,25.9z M10.9,15.9 c0-0.5-0.3-0.9-0.8-1.1c0-0.1,0-0.2,0-0.3v-2.7c0.1-0.1,0.3-0.4,0.6-0.5c0.4-0.2,0.6-0.6,0.6-1V7.5c0-1.4,0-3,5.3-3 c0.3,0,0.5-0.1,0.7-0.2C20.4,1.9,23.7,2.7,25,4c0.8,0.9,0.8,1.9,0,2.8c-0.2,0.2-0.3,0.4-0.3,0.7v2.8c0,0.4,0.2,0.8,0.6,1 c0.2,0.1,0.5,0.4,0.5,0.4v2.8c0,0.1,0,0.2,0,0.2c-0.6,0.1-1.1,0.6-1.1,1.2c0,3.2-3.9,7.2-7,7.2C14.5,23.2,10.9,19.2,10.9,15.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUsuario01);
export default __webpack_public_path__ + "static/media/ico-usuario-01.ceabbf3bb9dabff223d9e955507ddf2b.svg";
export { ForwardRef as ReactComponent };